import { render } from "./TopicDetailModal.vue?vue&type=template&id=5e836c4a&scoped=true"
import script from "./TopicDetailModal.vue?vue&type=script&lang=js"
export * from "./TopicDetailModal.vue?vue&type=script&lang=js"

import "./TopicDetailModal.vue?vue&type=style&index=0&id=5e836c4a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e836c4a"]])

export default __exports__